import { createHashHistory, createMemoryHistory } from 'history';
import { parse, stringify } from 'query-string';
import qhistory from 'qhistory';
import { isTest } from 'utilities/env';

/* Why createMemoryHistory?
 *    For test environment we dont have real Browser, hence we are using createMemoryHistory
 * How it works?
 *    All history object are from same prototype,
 *    this guarantee that all test and application code is dealing with the same history object.
 * */
const historyObject = isTest() ? createMemoryHistory({ initialEntries: ['/'] }) : createHashHistory();
const queryableHistory = qhistory(
  historyObject,
  stringify,
  parse
);

export default queryableHistory;
